<div #feedingTreeConflictModalWindow class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-copy">
    <div class="modal-content no-border border-radius-0">
      <div class="modal-header text-uppercase font-size-16">
        <div class="modal-title">
          <ng-container i18n="@@app.feeding_tree_conflict">Feeding tree conflict</ng-container>
        </div>
        <button type="button" (click)="cancelMove()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body mx-3 px-0">
        <div>
          <div>
            <div class="row mx-2 justify-content-center align-items-center">
              <div class="image-tree-conflict-border pl-2 col-md-2">
                <img alt="" src="/assets/images/attention_feeding_tree_icon.svg">
              </div>
              <div class="font-size-m col-md-10 font-weight-semibold">
                <ng-container i18n="@@app.feeding_tree_conflict_description">Changing this component will affect an existing "Feeding tree" wiring configuration. Do you wish to continue</ng-container>?
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pt-0 no-border">
        <button type="button" (click)="cancelMove()"
                class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2"
                i18n="@@app.cancel">Cancel</button>
        <button appDisableMultipleClick
                type="button"
                class="btn btn-danger btn-lg text-uppercase border-rounded mx-2 font-weight-normal" i18n="@@app.yes"
                (click)="onConfirm()">Yes</button>
      </div>
    </div>
  </div>
</div>
